export const INVALID_EMAIL_CLEARED = 'INVALID_EMAIL_CLEARED';

export const invalidEmailCleared = () => dispatch =>
  dispatch({
    type: INVALID_EMAIL_CLEARED,
  });
